import { z } from 'zod'

/**
 * Search params schema for users dashboard
 * This defines the structure of URL search parameters that persist filter state
 */
export const usersSearchSchema = z.object({
  // Search query
  query: z.string().optional(),
  
  // Filters
  tenantId: z.string().optional(),
  roleName: z.string().optional(), // Use role name instead of roleId in URL
  workstationId: z.union([z.string(), z.number()]).optional().transform((val) => {
    const raw = typeof val === 'number' ? val : val && val !== '' ? Number(val) : undefined
    return raw !== undefined && Number.isFinite(raw) && raw > 0 ? raw : undefined
  }),
  
  // Status filters (checkboxes)
  statusLocked: z.string().transform((val) => val === 'true').optional(),
  statusEnabled: z.string().transform((val) => val === 'true').optional(),
  
  // Pagination
  page: z.union([z.string(), z.number()]).optional().transform((val) => {
    const raw = typeof val === 'number' ? val : val && val !== '' ? Number(val) : 1
    return Number.isFinite(raw) && raw > 0 ? raw : 1
  }),
})

export type UsersSearchParams = z.infer<typeof usersSearchSchema>

